'use strict';

var react = require('@emotion/react');
var zIndex = require('../../../../constants/zIndex.cjs');

const wrapper = /*#__PURE__*/ react.css({
    padding: "8px 0",
    position: "relative",
    zIndex: zIndex.cardAction
}, "label:label-VariantDropdown-web-styleswrapper", "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2JlbmFpYWhiYXJhbmdvL2Rldi9hdmlhcnkvcGFja2FnZXMvYXZpYXJ5LXdlYi9zcmMvY29tcG9uZW50cy9wbGF0Zm9ybS9Qcm9kdWN0Q2FyZC9WYXJpYW50RHJvcGRvd24vVmFyaWFudERyb3Bkb3duLndlYi5zdHlsZXMudHMiLCJzb3VyY2VzIjpbIi9Vc2Vycy9iZW5haWFoYmFyYW5nby9kZXYvYXZpYXJ5L3BhY2thZ2VzL2F2aWFyeS13ZWIvc3JjL2NvbXBvbmVudHMvcGxhdGZvcm0vUHJvZHVjdENhcmQvVmFyaWFudERyb3Bkb3duL1ZhcmlhbnREcm9wZG93bi53ZWIuc3R5bGVzLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNzcyB9IGZyb20gXCJAZW1vdGlvbi9yZWFjdFwiO1xuXG5pbXBvcnQgeyB6SW5kZXggfSBmcm9tIFwiI2NvbnN0YW50c1wiO1xuXG5leHBvcnQgY29uc3Qgd3JhcHBlciA9IGNzcyh7XG4gIHBhZGRpbmc6IFwiOHB4IDBcIixcbiAgcG9zaXRpb246IFwicmVsYXRpdmVcIixcbiAgekluZGV4OiB6SW5kZXguY2FyZEFjdGlvbixcbn0pO1xuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUl1QiJ9 */");

exports.wrapper = wrapper;
//# sourceMappingURL=VariantDropdown.web.styles.cjs.map
